import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { DeleteOutlined } from '@ant-design/icons';
import { render } from '@react-email/render';
import { PreferitiModel } from 'Magazzino/Models/PreferitiModel';
import { Button, Form, Input, Popconfirm, Spin, Table, TableProps, Typography, message } from 'antd';
import FormItem from 'antd/es/form/FormItem';

import Configurazione from '../../Configurazione';
import Footer from '../../Footer';
import { GetErrorMessage } from '../../Utility';
import api from '../../api';
import stringres from '../../translations/stringres';
import EmailPreferiti from '../MagazzinoProprieta/EmailPreferiti';
import HeaderBarMagazzino from '../MagazzinoProprieta/HeaderBarMagazzino';
import { InvioEmailModel } from '../Models/InvioEmailModel';
import { GestionePreferiti } from './GestionePreferiti';

export default function Preferiti() {
    const [data, setData] = useState<PreferitiModel[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingDelete, setIsLoadingDelete] = useState(false);
    const recaptcha = useRef<ReCAPTCHA>(null);

    const [form] = Form.useForm();

    const fetchData = useCallback(async () => {
        setIsLoading(true);
        try {
            const fetchedData = await GestionePreferiti.getAll();
            setData(fetchedData);
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    function onDeletePreferito(e: PreferitiModel) {
        try {
            setIsLoadingDelete(true);

            GestionePreferiti.elimina(e.id);

            message.success(stringres.t('preferitoEliminato').toString());

            fetchData();
        } catch (error) {
            message.error(GetErrorMessage(error));
        } finally {
            setIsLoadingDelete(false);
        }
    }

    const columns: TableProps<PreferitiModel>['columns'] = [
        {
            title: '',
            dataIndex: 'img',
            key: 'img',
            width: '100px',
            render: (text, record: PreferitiModel) => (
                <div>
                    <img
                        style={{ width: '200px' }}
                        alt=""
                        src={Configurazione().apiBaseUrl + 'Magazzino/GetFoto?fotoNome=' + record?.nomeFile + '&tipo=3'}
                    ></img>
                </div>
            ),
        },
        {
            title: stringres.t('numeroBloccoshort').toString(),
            dataIndex: 'numeroBlocco',
            key: 'numeroBlocco',
            width: '100px',
        },
        {
            title: stringres.t('numeroBloccoFornitoreshort').toString(),
            dataIndex: 'numeroBloccoFornitore',
            key: 'numeroBloccoFornitore',
            width: '100px',
        },
        {
            title: stringres.t('qualita').toString(),
            dataIndex: 'qualita',
            key: 'qualita',
        },
        {
            title: stringres.t('spalt').toString(),
            dataIndex: 'spessore',
            key: 'spessore',
            width: '60px',
        },
        {
            title: stringres.t('pezzi').toString(),
            dataIndex: 'pezzi',
            key: 'pezzi',
            width: '60px',
        },
        {
            title: stringres.t('qta').toString(),
            dataIndex: 'qta',
            key: 'qta',
            width: '75px',
        },
        {
            title: stringres.t('um').toString(),
            dataIndex: 'um',
            key: 'um',
            width: '50px',
        },
        {
            title: '',
            dataIndex: '',
            key: '',
            width: '50px',
            render: (text, record: PreferitiModel) => (
                <div>
                    <Popconfirm
                        title={stringres.t('elimina').toString()}
                        description={stringres.t('eliminare?').toString()}
                        onConfirm={() => onDeletePreferito(record)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button icon={<DeleteOutlined />}></Button>
                    </Popconfirm>
                </div>
            ),
        },
    ];

    async function onSendEmail(event) {
        try {
            const captchaValue = recaptcha.current!.getValue();

            if (!captchaValue) {
                message.error(stringres.t('verificacaptcha').toString());
            } else {
                const b = await inviamail();
                if (b) message.info(stringres.t('inviata').toString());
            }
        } catch (error) {
            console.log('captchaerror', error);
            message.error(GetErrorMessage(error));
        }
    }

    async function inviamail() {
        try {
            const p: InvioEmailModel = {
                ragioneSociale: form.getFieldValue('ragionesociale'),
                nome: form.getFieldValue('nome'),
                cognome: form.getFieldValue('cognome'),
                email: form.getFieldValue('email'),
                indirizzo: form.getFieldValue('indirizzo'),
                partitaivacodfiscale: form.getFieldValue('partitaivacodfiscale'),
                telefono: form.getFieldValue('telefono'),
                preferiti: GestionePreferiti.getAll(),
            };
            const dt = {
                to: 'l.delveneziano@isodata.it',
                subject: 'oggetto',
                htmlBody: render(<EmailPreferiti parametri={p}></EmailPreferiti>),
            };
            const result = await api.post('Tabelle/SendMail', dt);
            if (result != null && result.data != null) {
                const dati = result.data[0];

                return true;
            }

            return false;
        } catch (error) {
            GetErrorMessage(error);

            return false;
        }
    }

    return (
        <div>
            <HeaderBarMagazzino descrizione="Magazzino" menuSelezionato="MagazzinoClienti"></HeaderBarMagazzino>
            <div style={{ marginTop: '50px', marginLeft: '100px', marginBottom: '25px' }}>
                <span
                    style={{
                        color: '#4b4e53',
                        fontFamily: 'Lato, Arial, Helvetica, sans-serif',
                        fontSize: '60px',
                        fontWeight: '300px',
                    }}
                >
                    RICHIEDI
                </span>
                <br />
                <span
                    style={{
                        color: '#4b4e53',
                        fontFamily: 'Lato, Arial, Helvetica, sans-serif',
                        fontSize: '60px',
                        fontWeight: 'bold',
                    }}
                >
                    QUOTAZIONE
                </span>
            </div>
            <Spin spinning={isLoading}>
                <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                    <Table
                        rowKey="id"
                        tableLayout="auto"
                        style={{
                            margin: '0px',
                            paddingLeft: '25px',
                            paddingRight: '25px',
                            paddingBottom: '25px',
                            width: '90%',
                        }}
                        scroll={{ x: 'max-content' }}
                        size="large"
                        dataSource={data}
                        columns={columns}
                    ></Table>
                </div>
            </Spin>
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        borderLeft: '2px solid #333',
                        width: '40%',
                        height: '150px',
                        marginLeft: '100px',
                        padding: '5px',
                        fontSize: '30px',
                    }}
                >
                    Benvenuti in <span style={{ fontWeight: 'bolder' }}>{Configurazione().companyname}</span>
                    <br></br>
                    <br></br>
                    <span style={{ fontSize: '25px', fontWeight: 'lighter' }}>
                        Accedi al catalogo.<br></br>O compila la <span>Registrazione</span>
                    </span>
                </div>
                <Form style={{ right: '10%', width: '40%' }} form={form} onFinish={onSendEmail} layout="vertical">
                    <FormItem
                        rules={[{ type: 'email', message: stringres.t('emailnonvalida'), required: true }]}
                        name="email"
                        label={stringres.t('email').toString()}
                    >
                        <Input></Input>
                    </FormItem>
                    <FormItem
                        name="ragioneSociale"
                        label={stringres.t('ragioneSociale').toString()}
                        className="Form-item-inline2componenti"
                        rules={[{ required: true, message: stringres.t('campoobbligatorio') }]}
                        style={{ paddingRight: '10px' }}
                    >
                        <Input size="large" />
                    </FormItem>
                    <FormItem
                        name="piva"
                        label={stringres.t('piva').toString() + ' / ' + stringres.t('codicefiscale').toString()}
                        className="Form-item-inline2componenti"
                    >
                        <Input size="large" />
                    </FormItem>
                    <FormItem
                        name="nome"
                        className="Form-item-inline2componenti"
                        style={{ paddingRight: '10px' }}
                        label={stringres.t('nome').toString()}
                    >
                        <Input size="large" />
                    </FormItem>
                    <FormItem
                        name="cognome"
                        className="Form-item-inline2componenti"
                        label={stringres.t('cognome').toString()}
                    >
                        <Input size="large" />
                    </FormItem>
                    <FormItem name="indirizzo" label={stringres.t('indirizzo').toString()}>
                        <Input size="large" />
                    </FormItem>
                    <FormItem name="telefono" label={stringres.t('telefono').toString()}>
                        <Input size="large" />
                    </FormItem>
                    <FormItem>
                        <ReCAPTCHA ref={recaptcha} sitekey={process.env.REACT_APP_SITE_KEY}></ReCAPTCHA>
                    </FormItem>
                    <FormItem>
                        <Button htmlType="submit" type="primary">
                            {stringres.t('inviamail').toString()}
                        </Button>
                    </FormItem>
                </Form>
            </div>
            <Footer></Footer>
        </div>
    );
}
